// material-ui
import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';

// project-imports
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';

// assets
import { Trash } from 'iconsax-react';
// types
interface Props {
    title?: string;
    open: boolean;
    desc?:string;
    handleClose: (status: boolean) => void;
  }
  
  
  export default function AlertDelete({ title, open, handleClose,desc }: Props) {
    return (
      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        keepMounted
        TransitionComponent={PopupTransition}
        maxWidth="xs"
        aria-labelledby="column-delete-title"
        aria-describedby="column-delete-description"
      >
        <DialogContent sx={{ mt: 2, my: 1 }}>
          <Stack alignItems="center" spacing={3.5}>
            <Avatar color="error" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
              <Trash variant="Bold" />
            </Avatar>
            <Stack spacing={2}>
              <Typography variant="h4" align="center">
               {title? title:"Are you sure you want to delete?"} 
              </Typography>
              <Typography align="center">
                {/* By deleting */}
                <Typography variant="subtitle1" component="span">
                  {/* {' '}
                  "{title}"{' '} */}
                  {desc}
                </Typography>
                {/* column, all task inside that column will also be deleted. */}
              </Typography>
            </Stack>
  
            <Stack direction="row" spacing={2} sx={{ width: 1 }}>
              <Button fullWidth onClick={() => handleClose(false)} color="secondary" variant="outlined">
                Cancel
              </Button>
              <Button fullWidth color="error" variant="contained" onClick={() => handleClose(true)} autoFocus>
                Delete
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }